import { render, staticRenderFns } from "./from0tohero.vue?vue&type=template&id=d63cf06a&scoped=true&"
import script from "./from0tohero.vue?vue&type=script&lang=js&"
export * from "./from0tohero.vue?vue&type=script&lang=js&"
import style0 from "./from0tohero.vue?vue&type=style&index=0&id=d63cf06a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d63cf06a",
  null
  
)

export default component.exports